// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list_title_box":"list_title_box-1deKhak3","list_title":"list_title-nOvTJ00k","big":"big-3QPOjsEI","normal":"normal-3eXTIeSy","space":"space-29AyRRCD"};